<div class="main-tab-title-box">
  <mat-card-title class="main-title">Readability</mat-card-title>
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<div *ngIf="isLessThan100Words" class="message">
  <div class="line"></div>
  <p>Readability scores are not accurate on short documents. These scores should only be considered for larger (100 word+) documents.</p>
</div>

<mat-card-content>

  <div class="readability-box" style="grid-column: span 2;">
    <div class="readability-box-sub" style="grid-column: span 2;">
      <div class="main-box-title-16">Flesch Reading Ease 
        <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">Measures how easy your text is to read. Higher scores indicate simpler, more accessible writing; lower scores indicate more complex text.</span>
        </div>
      </div>
      <div class="main-box-value-32">{{readability.flesch_reading ? readability.flesch_reading:"N/A"}}</div>
    </div>
    <div class="readability-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
      <div class="main-box-title-12">Very Low Readability</div>
      <div class="main-box-title-12">High Readability</div>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px; padding-bottom: 0px;">
      <div class="main-box-title-12">0</div>
      <div class="main-box-title-12">100</div>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
      <mat-progress-bar mode="determinate" value="{{readability.flesch_reading}}" color="accent"></mat-progress-bar>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2; text-align:left;">
      <div class="main-box-title-12"><b>The higher the score given, the easier a text is considered to read. Scores are typically between 0 and 100.</b>
        <br>
        <br>
        This measure is calculated according to a ratio of total words, sentences and syllables. See more details <a href="https://textinspector.com/help/statistics-readability/" class="hiperlinks" target="_blank" rel="noopener noreferrer">here</a>.
      </div>
    </div>
    <div *ngIf="readability.flesch_reading !== null && readability.flesch_reading !== undefined && readability.flesch_reading" [ngClass]="getBoxLineColorReading(readability.flesch_reading)">
      <div class="main-box-title-12">{{ getTextLineReading(readability.flesch_reading) }}</div>
    </div>
  </div>

  <div class="readability-box" style="grid-column: span 2; margin-top: 10px;">
    <div class="readability-box-sub" style="grid-column: span 2;">
      <div class="main-box-title-16">Flesch-Kincaid Grade <div class="tooltip-container">
        <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
        <span class="tooltip-text">Estimates the U.S. school grade level required to understand your text. Higher scores indicate more advanced reading difficulty.</span>
      </div></div>
      <div class="main-box-value-32">{{readability.flesch_kincaid ? readability.flesch_kincaid:"N/A"}}</div>
    </div>
    <div class="readability-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px; ">
      <div class="main-box-title-12">High Readability</div>
      <div class="main-box-title-12">Very Low Readability</div>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px; padding-bottom: 0px;">
      <div class="main-box-title-12">0</div>
      <div class="main-box-title-12">18</div>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
      <mat-progress-bar mode="determinate" [value]="(readability.flesch_kincaid ?? 0) / 18 * 100" color="accent"></mat-progress-bar>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2; text-align:left;">
      <div class="main-box-title-12"><b>The higher the score, the more complex a text is to read. While scores are typically between 0 and 18, the lowest grade level in theory is -3.40 and there is no upper bound.</b>
        <br>
        <br>
        Results corresponds to a U.S. grade level. This measure is also calculated according to a ratio of total words, sentences and syllables, but the weighting given to each of these factors is different to the Flesch Reading Ease score. See more details <a href="https://textinspector.com/help/statistics-readability/" class="hiperlinks" target="_blank" rel="noopener noreferrer">here</a>.</div>
    </div>
    <div *ngIf="readability.flesch_kincaid !== null && readability.flesch_kincaid !== undefined && readability.flesch_kincaid" [ngClass]="getBoxLineColorKincaid(readability.flesch_kincaid)">
      <div class="main-box-title-12">{{ getTextLineKincaid(readability.flesch_kincaid) }}</div>
    </div>
  </div>

  <div class="readability-box" style="grid-column: span 2;">
    <div class="readability-box-sub" style="grid-column: span 2;">
      <div class="main-box-title-16">Gunning Fog Index  <div class="tooltip-container">
        <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
        <span class="tooltip-text">Estimates the years of education needed to understand your text on first reading. Higher scores indicate more complex writing.</span>
      </div></div>
      <div class="main-box-value-32">{{readability.gunning_fog ? readability.gunning_fog:"N/A"}}</div>
    </div>
    <div class="readability-box-sub" style="margin-bottom: 0px; padding-bottom: 0px; padding-top: 0px;">
      <div class="main-box-title-12">High Readability</div>
      <div class="main-box-title-12">Very Low Readability</div>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px; padding-bottom: 0px;">
      <div class="main-box-title-12">0</div>
      <div class="main-box-title-12">20</div>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2;  padding-top: 0px;">
      <mat-progress-bar mode="determinate" [value]="(readability.gunning_fog ?? 0) / 20 * 100" color="accent"></mat-progress-bar>
    </div>
    <div class="readability-box-sub" style="grid-column: span 2; text-align:left;">
      <div class="main-box-title-12"><b>The higher the score, the more complex the text is to read. Scores are typically between 0 and 20.</b>
        <br>
        <br>
        The index estimates the years of formal education a person needs to understand the text. Texts for a wide audience generally need a score of less than 12. See more details <a href="https://textinspector.com/help/statistics-readability/" class="hiperlinks" target="_blank" rel="noopener noreferrer">here</a>.
      </div>
    </div>
    <div *ngIf="readability.gunning_fog !== null && readability.gunning_fog !== undefined && readability.gunning_fog" [ngClass]="getBoxLineColorFog(readability.gunning_fog)">
      <div class="main-box-title-12">{{ getTextLineFog(readability.gunning_fog) }}</div>
    </div>
  </div>

</mat-card-content>